<template>
  <div class="masterdata-right">
    <div class="masterdata-table">
      <table class="table-db table-db-hover">
        <thead>
          <tr>
            <th v-if="isEdit" class="editRow"></th>
            <th @click="sort('nomor')">
              Nomor
              <i
                :class="
                  currentSort === 'nomor'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('kode_negara')">
              Kode Negara
              <i
                :class="
                  currentSort === 'kode_negara'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('negara')">
              Negara
              <i
                :class="
                  currentSort === 'negara'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('kode_telepon')">
              Kode Telepon
              <i
                :class="
                  currentSort === 'kode_telepon'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('mata_uang')">
              Mata Uang
              <i
                :class="
                  currentSort === 'mata_uang'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('kode_mata_uang')">
              Kode Mata Uang
              <i
                :class="
                  currentSort === 'kode_mata_uang'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('updatedAt')">
              Last Modified Date
              <i
                :class="
                  currentSort === 'updatedAt'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('update_by')">
              Last Modified By
              <i
                :class="
                  currentSort === 'update_by'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('active')">
              active
              <i
                :class="
                  currentSort === 'active'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('note')">
              catatan
              <i
                :class="
                  currentSort === 'note'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(list, index) in sortedData" :key="index">
            <td v-if="isEdit" class="editRow" @click="editRow(list)">
              <span class="fa fa-edit pointer ml20"></span>
            </td>
            <td>{{ index + 1 }}</td>
            <td>{{ list.kode_negara }}</td>
            <td>{{ list.negara }}</td>
            <td>{{ list.kode_telepon }}</td>
            <td>{{ list.mata_uang }}</td>
            <td>{{ list.kode_mata_uang }}</td>
            <td>{{ formatDate(list.updatedAt) }}</td>
            <td>{{ $get(list, 'user.name', '-') }}</td>
            <td :style="list.active ? 'color:green' : 'color:red'">
              {{ list.active ? 'active' : 'inactive' }}
            </td>
            <td>{{ list.note }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <KBLI
      v-if="showModalEdit"
      :editData="editData"
      @closeModal="closeModal"
      class="notAll"
    />
  </div>
</template>

<script>
export default {
  components: {
    KBLI: () => import('@/views/MasterData/Edit/LegalDoc/Negara.vue'),
  },

  props: {
    isEdit: Boolean,
  },
  data() {
    return {
      currentSort: '',
      currentSortDir: '',
      arrow: false,
      showModalEdit: false,
      editData: {
        id: 0,
        kode_negara: '',
        negara: '',
        kode_telepon: '',
        mata_uang: '',
        kode_mata_uang: '',
        updatedAt: '',
        update_by: '',
        active: '',
        note: '',
      },
      data: [
        {
          nomor: 1,
          kode_negara: 'AF',
          negara: 'Afghanistan',
          kode_telepon: 93,
          mata_uang: 'Afghani',
          kode_mata_uang: 'AFA',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 1',
        },
        {
          nomor: 2,
          kode_negara: 'ZA',
          negara: 'South Africa',
          kode_telepon: 27,
          mata_uang: 'Rand',
          kode_mata_uang: 'ZAR',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 2',
        },
        {
          nomor: 3,
          kode_negara: 'AL',
          negara: 'Albania',
          kode_telepon: 355,
          mata_uang: 'Leke',
          kode_mata_uang: 'ALL',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 3',
        },
        {
          nomor: 4,
          kode_negara: 'DZ',
          negara: 'Algeria',
          kode_telepon: 213,
          mata_uang: 'Dinar Algeria',
          kode_mata_uang: 'DZD',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 4',
        },
        {
          nomor: 5,
          kode_negara: 'US',
          negara: 'USA',
          kode_telepon: 1,
          mata_uang: 'Dollar',
          kode_mata_uang: 'USD',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 5',
        },
        {
          nomor: 6,
          kode_negara: 'AD',
          negara: 'Andorran',
          kode_telepon: 376,
          mata_uang: 'Euro',
          kode_mata_uang: 'EUR',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 6',
        },
        {
          nomor: 7,
          kode_negara: 'AO',
          negara: 'Angola',
          kode_telepon: 244,
          mata_uang: 'Kwanza',
          kode_mata_uang: 'AOA',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 7',
        },
        {
          nomor: 8,
          kode_negara: 'AG',
          negara: 'Antigua/Barbuda',
          kode_telepon: '1-268',
          mata_uang: 'Dollar',
          kode_mata_uang: 'XCD',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 8',
        },
        {
          nomor: 9,
          kode_negara: 'SA',
          negara: 'Saudi Arabia',
          kode_telepon: 966,
          mata_uang: 'Riyal',
          kode_mata_uang: 'SAR',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 9',
        },
        {
          nomor: 10,
          kode_negara: 'AR',
          negara: 'Argentina',
          kode_telepon: 54,
          mata_uang: 'Peso',
          kode_mata_uang: 'ARS',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 10',
        },
        {
          nomor: 11,
          kode_negara: 'AM',
          negara: 'Armenia',
          kode_telepon: 374,
          mata_uang: 'Dram',
          kode_mata_uang: 'AMD',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 11',
        },
        {
          nomor: 12,
          kode_negara: 'AU',
          negara: 'Australia',
          kode_telepon: 61,
          mata_uang: 'Dollar',
          kode_mata_uang: 'AUD',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 12',
        },
        {
          nomor: 13,
          kode_negara: 'AT',
          negara: 'Austria',
          kode_telepon: 43,
          mata_uang: 'Euro',
          kode_mata_uang: 'EUR',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 13',
        },
        {
          nomor: 14,
          kode_negara: 'AZ',
          negara: 'Azerbaijan',
          kode_telepon: 994,
          mata_uang: 'Manat',
          kode_mata_uang: 'AZN',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 14',
        },
        {
          nomor: 15,
          kode_negara: 'BS',
          negara: 'Bahamas',
          kode_telepon: '1-242',
          mata_uang: 'Dollar',
          kode_mata_uang: 'BSD',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 15',
        },
      ],
    }
  },

  methods: {
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
      }
      this.currentSort = s
    },
    editRow(data) {
      this.editData = {
        id: data.id,
        kode_negara: data.kode_negara,
        negara: data.negara,
        kode_telepon: data.kode_telepon,
        mata_uang: data.mata_uang,
        kode_mata_uang: data.kode_mata_uang,
        updatedAt: data.updatedAt,
        update_by: data.update_by,
        active: data.active,
        note: data.note,
      }
      this.showModalEdit = true
    },
    closeModal() {
      this.showModalEdit = false
    },
  },

  computed: {
    negaraData() {
      const result = this.$store.state.mdDatabaseStore.negaraData
      return result
    },
    sortedData() {
      return this.negaraData.sort((a, b) => {
        let modifier = 1
        if (this.currentSortDir === 'desc') modifier = -1
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
        return 0
      })
    },
  },
}
</script>
